const IMAGE_API = '/api/image';

const isUnsplash = (url) => {
  try {
    return new URL(url).hostname === 'images.unsplash.com';
  } catch {
    return false;
  }
};

const isPexels = (url) => {
  try {
    return new URL(url).hostname === 'images.pexels.com';
  } catch {
    return false;
  }
};

const isLocalUpload = (url) => {
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.pathname.startsWith('/uploads/');
  } catch {
    return url.startsWith('/uploads/');
  }
};

const optimizeUnsplashUrl = (src, width, quality, format) => {
  const url = new URL(src);
  url.searchParams.set('crop', 'entropy');
  url.searchParams.set('cs', 'srgb');
  if (format === 'auto') {
    url.searchParams.set('auto', 'format');
    url.searchParams.delete('fm');
  } else {
    url.searchParams.set('fm', format);
  }
  url.searchParams.set('q', String(quality));
  url.searchParams.set('w', String(width));
  return url.toString();
};

const optimizePexelsUrl = (src, width, quality, format) => {
  const url = new URL(src);
  url.searchParams.delete('dpr'); // let srcSet handle device pixel ratio
  url.searchParams.delete('h');  // let CDN scale proportionally by width only
  url.searchParams.delete('fit');
  url.searchParams.set('auto', 'compress');
  url.searchParams.set('cs', 'tinysrgb');
  url.searchParams.set('fm', format === 'auto' || format === 'avif' ? 'webp' : format);
  url.searchParams.set('w', String(width));
  url.searchParams.set('q', String(quality));
  return url.toString();
};

export const optimizeImageUrl = (src, width = 960, quality = 90, format = 'auto') => {
  if (!src || src.startsWith('data:') || src.includes('/api/image?')) return src;

  if (isUnsplash(src)) return optimizeUnsplashUrl(src, width, quality, format);
  if (isPexels(src)) return optimizePexelsUrl(src, width, quality, format);

  if (!isLocalUpload(src)) return src;

  const params = new URLSearchParams({
    src,
    w: String(width),
    q: String(quality),
    fmt: format,
  });
  return `${IMAGE_API}?${params.toString()}`;
};

export const buildImageSrcSet = (src, widths = [320, 640], quality = 90, format = 'auto') => {
  const getQ = (i) => Array.isArray(quality) ? (quality[i] ?? quality[quality.length - 1]) : quality;
  return widths.map((width, i) => `${optimizeImageUrl(src, width, getQ(i), format)} ${width}w`).join(', ');
};
